import React from 'react';
import { Outlet } from 'react-router-dom';

export default function WrappedLayout() {
  return (
    <div className="gf_app">
      <div id="reactPlugin" className="react-ui">
        <Outlet />
      </div>
    </div>
  );
}
